"use strict";
/**
 * Typed DynamoDB Query Helpers
 *
 * Generic wrappers around DynamoDB DocumentClient operations that return
 * properly typed results. These isolate the single necessary type coercion
 * to this utility module, eliminating ~30+ scattered `as unknown as Type`
 * coercions across lambda packages.
 *
 * Consumers: lambda-main, lambda-secure, lambda-utilities, shared-types/database/operations-client
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.typedGet = typedGet;
exports.typedQuery = typedQuery;
exports.typedBatchGet = typedBatchGet;
const lib_dynamodb_1 = require("@aws-sdk/lib-dynamodb");
/**
 * Execute a typed DynamoDB GetCommand.
 *
 * @param client - DynamoDB DocumentClient instance
 * @param params - Standard GetCommandInput (TableName + Key)
 * @returns Typed result with Item as T | undefined
 */
async function typedGet(client, params) {
    const result = await client.send(new lib_dynamodb_1.GetCommand(params));
    // Justified coercion: DynamoDB SDK returns Record<string, AttributeValue> but we know
    // the shape from our type definitions. This is the single permitted coercion point.
    return result;
}
/**
 * Execute a typed DynamoDB QueryCommand.
 *
 * @param client - DynamoDB DocumentClient instance
 * @param params - Standard QueryCommandInput (TableName, KeyConditionExpression, etc.)
 * @returns Typed result with Items as T[] | undefined
 */
async function typedQuery(client, params) {
    const result = await client.send(new lib_dynamodb_1.QueryCommand(params));
    // Justified coercion: DynamoDB SDK returns Record<string, AttributeValue>[] but we know
    // the shape from our type definitions. This is the single permitted coercion point.
    return result;
}
/**
 * Execute a typed DynamoDB BatchGetCommand.
 *
 * @param client - DynamoDB DocumentClient instance
 * @param params - Standard BatchGetCommandInput (RequestItems with table-keyed Keys)
 * @returns Typed result with Responses keyed by table name containing T[]
 */
async function typedBatchGet(client, params) {
    const result = await client.send(new lib_dynamodb_1.BatchGetCommand(params));
    // Justified coercion: DynamoDB SDK returns Record<string, AttributeValue>[] per table
    // but we know the shape from our type definitions. This is the single permitted coercion point.
    return result;
}
